import { render, staticRenderFns } from "./PrequalPage.vue?vue&type=template&id=5635f53c&"
import script from "./PrequalPage.vue?vue&type=script&lang=js&"
export * from "./PrequalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports